import { WarningFilled } from '@/assets/icons/warning';
import { useNetworkQuality } from '@/hooks/use-network-quality';
import { useTranslation } from '@/hooks/use-translation';
import { cn } from '@/lib/utils';

export const NetworkStatusIndicator = ({
  className = '',
  showText = true,
}: { className?: string; showText?: boolean }) => {
  const { isOnline, isPoorQuality } = useNetworkQuality();
  const { t } = useTranslation('desktop_common');

  if (isOnline && !isPoorQuality) {
    return null;
  }

  return (
    <div
      className={cn(
        'flex items-center justify-center bg-white border border-primary/30 rounded-md py-0.5 pl-2 pr-3 w-fit gap-1 z-popover',
        className,
      )}
    >
      <WarningFilled
        className={cn('w-4 h-4 fill-extra-decline shrink-0', !isOnline && 'fill-danger')}
      />
      {isPoorQuality && showText && (
        <span className="font-semibold text-body-12 line-clamp-1 break-all">
          {t('networkQuality.slowConnection')}
        </span>
      )}
      {!isOnline && showText && (
        <span className="font-semibold text-body-12 line-clamp-1 break-all">
          {t('networkQuality.offline')}
        </span>
      )}
    </div>
  );
};
